import { useNavigate } from 'react-router-dom'
import { AppBar, Box, Toolbar, useTheme } from '@mui/material'

import { Institution } from 'domain/entities/representative'
import { urlRoutes } from 'presentation/routes/config/urlRoutes/urlRoutes'
import LogoIcon from 'presentation/assets/icons/logoHeader.svg'
import { useHeader } from './hooks'
import { HeaderNavItems, HeaderSignInItem } from './components'

function Header() {
  const navigate = useNavigate()
  const theme = useTheme()
  const {
    handleCloseSignInMenu,
    isOpenSignInMenu,
    user,
    logged,
    handleClickListSignInItemMenu,
    anchorSignInEl,
    isOpenNotificationsMenu,
    handleClickListNotificationsItemMenu,
    handleGetNotifications,
    isOpenStudentMenu,
    isOpenUserMenu,
    anchorStudentEl,
    handleClickListUserItemMenu,
    handleClickItemMenu,
    anchorUserEl,
    handleCloseNotificationsMenu,
    handleClickMainMenu,
    selectedItemMenu,
    handleCloseUserMenu,
    handleCloseStudentMenu,
    handleCloseBackdrop,
    handleOpenBackdrop,
    notifications,
    isLoading,
    errorGetInstitutionsByRepresentative,
    institutions,
    error,
    handleClickListStudentItemMenu,
    anchorNotificationsEl,
    idsArray,
    isOpenBackdrop,
  } = useHeader()

  const handleRedirect = () => {
    if (logged && !user?.firstLogin) {
      navigate(urlRoutes.private.goalAssignment.urlTo)
    } else if (!logged) {
      navigate(urlRoutes.public.auth.login.urlTo)
    }
  }

  return (
    <AppBar position="fixed" sx={{ borderBottom: `2px solid ${theme.palette.info.main}` }}>
      <Toolbar
        sx={{
          backgroundColor: 'primary',
          alignItems: 'center',
          alignSelf: 'center',
          padding: logged ? '13px 27px' : '15px 27px',
          minHeight: '80px',
          height: 'auto',
          maxWidth: '1700px',
          width: '100%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            marginRight: '120px',
            alignItems: 'left',
            cursor: user?.firstLogin ? 'default' : 'pointer',
          }}
          onClick={handleRedirect}
        >
          <img alt="Logo" src={LogoIcon} />
        </Box>
        {logged && !user?.firstLogin ? (
          <HeaderNavItems
            isOpenNotificationsMenu={isOpenNotificationsMenu}
            isOpenUserMenu={isOpenUserMenu}
            anchorStudentEl={anchorStudentEl}
            isOpenStudentMenu={isOpenStudentMenu}
            handleCloseUserMenu={handleCloseUserMenu}
            handleCloseStudentMenu={handleCloseStudentMenu}
            handleCloseNotificationsMenu={handleCloseNotificationsMenu}
            anchorNotificationsEl={anchorNotificationsEl}
            handleClickListNotificationsItemMenu={handleClickListNotificationsItemMenu}
            selectedItemMenu={selectedItemMenu as Institution}
            institutions={institutions}
            handleClickMainMenu={handleClickMainMenu}
            errorGetInstitutionsByRepresentative={errorGetInstitutionsByRepresentative as string}
            handleClickListStudentItemMenu={handleClickListStudentItemMenu}
            handleClickItemMenu={handleClickItemMenu}
            error={error as string}
            notifications={notifications}
            handleOpenBackdrop={handleOpenBackdrop}
            handleClickListUserItemMenu={handleClickListUserItemMenu}
            anchorUserEl={anchorUserEl}
            isOpenBackdrop={isOpenBackdrop}
            isLoading={isLoading}
            handleCloseBackdrop={handleCloseBackdrop}
            idsArray={idsArray}
            handleGetNotifications={handleGetNotifications}
          />
        ) : (
          !logged && (
            <HeaderSignInItem
              handleClickListSignInItemMenu={handleClickListSignInItemMenu}
              anchorSignInEl={anchorSignInEl}
              handleCloseSignInMenu={handleCloseSignInMenu}
              isOpenSignInMenu={isOpenSignInMenu}
            />
          )
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Header
